import { Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { view as view_11, Model_Default, update as update_3, init as init_9, Msg_$reflection as Msg_$reflection_3, Model_$reflection as Model_$reflection_1 } from "./Pages/Index.js";
import { view as view_7, update as update_4, init as init_2, Msg_$reflection as Msg_$reflection_5, Model_$reflection as Model_$reflection_2 } from "./Pages/About.js";
import { view as view_8, update as update_5, init as init_3, Msg_$reflection as Msg_$reflection_6, Model_$reflection as Model_$reflection_3 } from "./Pages/ContactForm.js";
import { view as view_10, update as update_2, init as init_1, Msg_$reflection as Msg_$reflection_4, Model_$reflection as Model_$reflection_4 } from "./Pages/Login.js";
import { view as view_9, update as update_6, init as init_4, Msg_$reflection as Msg_$reflection_7, Model_$reflection as Model_$reflection_5 } from "./Pages/StaticPage.js";
import { record_type, bool_type, int32_type, class_type, option_type, list_type, tuple_type, union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { ViewProfile_view, AddEditProfile_view, AddEditProfile_update, ViewProfile_update, AddEditProfile_initEdit, AddEditProfile_initNew, ViewProfile_init, AddEditProfile_Msg_$reflection, ViewProfile_Msg_$reflection, AddEditProfile_Model_$reflection, ViewProfile_Model_$reflection } from "./Pages/MyProfile.js";
import { view as view_2, update as update_7, init as init_5, Msg_$reflection as Msg_$reflection_8, Model_$reflection as Model_$reflection_6 } from "./modules/Omnicv.Diary.Client/Pages/MainDiaryView.js";
import { view as view_3, update as update_8, SearchType, init as init_6, Msg_$reflection as Msg_$reflection_9, Model_$reflection as Model_$reflection_7 } from "./modules/Omnicv.Diary.Client/Pages/SearchDiaryView.js";
import { InteractionRecord_$reflection, ReviewRecord_$reflection, DiaryRecord_$reflection } from "./modules/Omnicv.Diary.Shared/Data.js";
import { EditHelperData$1_$reflection } from "./modules/Omnicv.Diary.Shared/DiaryAPI.js";
import { Msg$2, Model$2__IsEditing, Msg$2_$reflection, Model$2_$reflection } from "./Omnicv.Client.Common/Components/AddEditRecordFlexFormBase.js";
import { TemperatureRecord_$reflection, BloodPressureRecord_$reflection, BodilyFunctionsRecord_$reflection, WeightRecord_$reflection, UnifiedRecord_$reflection } from "./Omnicv.Shared/PhysicalAPI.js";
import { Msg$1_$reflection, Model$1_$reflection } from "./Omnicv.Client.Common/Components/ViewRecords.js";
import { EventInfo_$reflection } from "./Omnicv.Shared.Common/CoreEventInfo.js";
import { Main_view, Main_update, Main_init, Msg_$reflection as Msg_$reflection_10, Model_$reflection as Model_$reflection_8 } from "./Pages/Financial/MainFinancialView.js";
import { view as view_4, update as update_9, init as init_7, Msg_$reflection as Msg_$reflection_11, Model_$reflection as Model_$reflection_9 } from "./Pages/Financial/ViewAsset.js";
import { view as view_5, update as update_10, init as init_8, Msg_$reflection as Msg_$reflection_12, Model_$reflection as Model_$reflection_10 } from "./Pages/Financial/ViewAssetsSummary.js";
import { ExerciseRecord_view, Exercise_view, Workout_view, TrainingPlan_view, Main_view as Main_view_1, ExerciseRecord_update, Exercise_update, Workout_update, TrainingPlan_update, Main_update as Main_update_1, ExerciseRecord_init, Exercise_init, Workout_init, TrainingPlan_init, Main_init as Main_init_1, ExerciseRecord_Msg_$reflection, Msg$2_$reflection as Msg$2_$reflection_1, Main_Msg_$reflection, ExerciseRecord_Model_$reflection, Model$2_$reflection as Model$2_$reflection_1, Main_Model_$reflection } from "./Pages/Fitness/MainFitnessView.js";
import { WorkoutRecord, WorkoutRecord_$reflection, ExerciseRecord_$reflection, WorkoutRecords_$reflection, FitnessEditHelperData_$reflection, TrainingPlan_$reflection, TrainingPlanWorkoutRecords_$reflection, Exercise_$reflection, Workout_$reflection } from "./Omnicv.Shared/FitnessAPI.js";
import { Exercises_view, Workouts_view, Exercises_update, Workouts_update, Exercises_init, Workouts_init, Msg$1_$reflection as Msg$1_$reflection_1, Model$1_$reflection as Model$1_$reflection_1 } from "./Pages/Fitness/FitnessEntriesView.js";
import { SimpleFormView$2__Update, Msg$2_$reflection as Msg$2_$reflection_2, Model$2_$reflection as Model$2_$reflection_2 } from "./Omnicv.Client.Common/Components/AddEditSimpleFlexFormBase.js";
import { ExerciseRecordsMany_view, view as view_6, ExerciseRecordsMany_mapModelToEIMMsg, mapModelToEIMMsg, ExerciseRecordsMany_update, getSetTimerMsg, update as update_11, ExerciseRecordsMany_initNewMany, initEdit, initNew, ExerciseRecordsMany_MsgMany_$reflection, Msg_$reflection as Msg_$reflection_13, ExerciseRecordsMany_ModelMany_$reflection, Model_$reflection as Model_$reflection_11 } from "./Pages/Fitness/AddEditExerciseRecord.js";
import { RouteModule_routeParser, Route, Route_$reflection } from "./Omnicv.Client.Common/Router.js";
import { view as view_12, init as init_10, LogInState, update as update_1, Msg as Msg_1, Model_$reflection as Model_$reflection_12, Msg_$reflection as Msg_$reflection_1 } from "./Components/Navigation.js";
import { Response_AvailableUserInfo_$reflection } from "./Omnicv.Shared/API.js";
import { subscribeLocation as subscribeLocation_1, Msg_$reflection as Msg_$reflection_2 } from "./Omnicv.Client.Common/Components/EventInfoManager.js";
import { Session__GetCurrentProfile, Session_get_Default, Session, Session__SetActiveWorkoutRecord_Z2D8A2414, Session__UpdateCurrentProvile, Session__GetActiveWorkoutRecord, Session_$reflection } from "./Omnicv.Client.Common/SharedView.js";
import { some, value as value_15, map } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { Cmd_batch, Cmd_map, Cmd_none } from "./fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { DiaryEditingView$1__View, DiaryEditingView$1__Update, interactionEditing, reviewEditing, DiaryEditingView$1__InitEdit, diaryEditing, DiaryEditingView$1__InitNew } from "./modules/Omnicv.Diary.Client/Pages/AddEditDiaryView.js";
import { WeightView_viewList, BodilyFunctionsView_viewList, PhysicalView_view, WeightView_update, BodilyFunctionsView_update, PhysicalView_update, WeightView_init, BodilyFunctionsView_init, PhysicalView_init } from "./Pages/Physical/MainPhysicalView.js";
import { Physical_PhysicalView$1__View, Physical_PhysicalView$1__Update, Physical_temperatureEditing, Physical_bodilyFunctionsEditing, Physical_bloodPressureEditing, Physical_PhysicalView$1__InitEdit, Physical_weightEditing, Physical_PhysicalView$1__InitNew_5D846BF8 } from "./Pages/Physical/AddEditPhysicalView.js";
import { AddEditFitnessView$1__View, exerciseEditing, workoutEditing, AddEditFitnessView$1__InitEdit, trainingPlanEditing, AddEditFitnessView$1__InitNew_5D846BF8 } from "./Pages/Fitness/AddEditFitnessView.js";
import { Workout_WorkoutEditView__View, Workout_WorkoutEditView__Update, Workout_WorkoutEditView__InitEdit, workoutRecordEditor, Workout_WorkoutEditView__InitNew } from "./Pages/Fitness/AddEditWorkoutRecord.js";
import { empty, ofArray, singleton } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, uncurry2, equals } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Cmd_OfAsync_start, Cmd_OfAsyncWith_either } from "./fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { anonService } from "./Omnicv.Client.Common/CommonServer.js";
import * as common from "../src/javascript/common.js";
import { box$0027 } from "./fable_modules/Fulma.3.0.0/Elements/Box.fs.js";
import { Common_lazyView2 } from "./fable_modules/Fable.Elmish.React.4.0.0/common.fs.js";
import { createElement } from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Router_href } from "./Omnicv.Client.Common/Router.js";
import { Helpers_combineClasses } from "./fable_modules/Feliz.Bulma.3.0.0/ElementBuilders.fs.js";
import { singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { renderCatchSimple } from "./Omnicv.Client.Common/ReactErrorBoundary.js";
import { footer } from "./fable_modules/Fulma.3.0.0/Layouts/Footer.fs.js";
import { Option, content } from "./fable_modules/Fulma.3.0.0/Elements/Content.fs.js";
import { Modifier_IModifier, TextAlignment_Option, Screen } from "./fable_modules/Fulma.3.0.0/Common.fs.js";
import { ProgramModule_mkProgram, ProgramModule_withSubscription, ProgramModule_run } from "./fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { Program_withReactSynchronous } from "./fable_modules/Fable.Elmish.React.4.0.0/react.fs.js";
import { ProgramModule_toNavigable } from "./fable_modules/Fable.Elmish.Browser.4.0.3/navigation.fs.js";
import { parseHash } from "./fable_modules/Fable.Elmish.Browser.4.0.3/parser.fs.js";

export function Tuple_mapFirst(f, x, y) {
    return [f(x), y];
}

export function Tuple_mapSecond(f, x, y) {
    return [x, f(y)];
}

export class AnonymousPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Index", "NotFound", "About", "ContactForm", "Login", "StaticPage"];
    }
}

export function AnonymousPage_$reflection() {
    return union_type("Omnicv.Client.App.AnonymousPage", [], AnonymousPage, () => [[["Item", Model_$reflection_1()]], [], [["Item", Model_$reflection_2()]], [["Item", Model_$reflection_3()]], [["Item", Model_$reflection_4()]], [["Item", Model_$reflection_5()]]]);
}

export class SessionPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MyProfile", "AddEditProfile", "ViewDiary", "SearchDiary", "AddEditDiary", "AddEditReview", "AddEditInteraction", "ViewPhysical", "ViewWeight", "ViewBodilyFunctions", "AddEditWeight", "AddEditBloodPressure", "AddEditBodilyFunctions", "AddEditTemperature", "ViewFinancial", "ViewAsset", "ViewAssetsSummary", "ViewFitness", "ViewWorkouts", "ViewExercises", "ViewTrainingPlan", "AddEditTrainingPlan", "ViewWorkout", "AddEditWorkout", "ViewExercise", "AddEditExercise", "ViewExerciseRecord", "AddEditExerciseRecord", "AddAllWorkoutExerciseRecords", "AddEditWorkoutRecord"];
    }
}

export function SessionPage_$reflection() {
    return union_type("Omnicv.Client.App.SessionPage", [], SessionPage, () => [[["Item", ViewProfile_Model_$reflection()]], [["Item", AddEditProfile_Model_$reflection()]], [["Item", Model_$reflection_6()]], [["Item", Model_$reflection_7()]], [["Item", Model$2_$reflection(DiaryRecord_$reflection(), EditHelperData$1_$reflection(DiaryRecord_$reflection()))]], [["Item", Model$2_$reflection(ReviewRecord_$reflection(), EditHelperData$1_$reflection(ReviewRecord_$reflection()))]], [["Item", Model$2_$reflection(InteractionRecord_$reflection(), EditHelperData$1_$reflection(InteractionRecord_$reflection()))]], [["Item", Model$1_$reflection(UnifiedRecord_$reflection())]], [["Item", Model$1_$reflection(WeightRecord_$reflection())]], [["Item", Model$1_$reflection(BodilyFunctionsRecord_$reflection())]], [["Item", Model$2_$reflection(WeightRecord_$reflection(), list_type(tuple_type(EventInfo_$reflection(), WeightRecord_$reflection())))]], [["Item", Model$2_$reflection(BloodPressureRecord_$reflection(), list_type(tuple_type(EventInfo_$reflection(), BloodPressureRecord_$reflection())))]], [["Item", Model$2_$reflection(BodilyFunctionsRecord_$reflection(), list_type(tuple_type(EventInfo_$reflection(), BodilyFunctionsRecord_$reflection())))]], [["Item", Model$2_$reflection(TemperatureRecord_$reflection(), list_type(tuple_type(EventInfo_$reflection(), TemperatureRecord_$reflection())))]], [["Item", Model_$reflection_8()]], [["Item", Model_$reflection_9()]], [["Item", Model_$reflection_10()]], [["Item", Main_Model_$reflection()]], [["Item", Model$1_$reflection_1(Workout_$reflection())]], [["Item", Model$1_$reflection_1(Exercise_$reflection())]], [["Item", Model$2_$reflection_1(TrainingPlanWorkoutRecords_$reflection(), Workout_$reflection())]], [["Item", Model$2_$reflection_2(TrainingPlan_$reflection(), FitnessEditHelperData_$reflection())]], [["Item", Model$2_$reflection_1(WorkoutRecords_$reflection(), Exercise_$reflection())]], [["Item", Model$2_$reflection_2(Workout_$reflection(), FitnessEditHelperData_$reflection())]], [["Item", Model$2_$reflection_1(Exercise_$reflection(), tuple_type(EventInfo_$reflection(), ExerciseRecord_$reflection()))]], [["Item", Model$2_$reflection_2(Exercise_$reflection(), FitnessEditHelperData_$reflection())]], [["Item", ExerciseRecord_Model_$reflection()]], [["Item", Model_$reflection_11()]], [["Item", ExerciseRecordsMany_ModelMany_$reflection()]], [["Item", Model$2_$reflection(WorkoutRecord_$reflection(), WorkoutRecords_$reflection())]]]);
}

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Anon", "Auth"];
    }
}

export function Page_$reflection() {
    return union_type("Omnicv.Client.App.Page", [], Page, () => [[["Item", AnonymousPage_$reflection()]], [["Item", SessionPage_$reflection()]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetRoute", "SetRouteValue", "NavigationMsg", "TimeTick", "RefreshSession", "SessionRefreshed", "SetCurrentProfile", "SessionRefreshError", "AppEIMMsg", "IndexMsg", "LoginMsg", "AboutMsg", "ContactFormMsg", "StaticPageMsg", "MyProfileMsg", "AddEditProfileMsg", "ViewDiaryMsg", "AddEditDiaryMsg", "AddEditReviewMsg", "AddEditInteractionMsg", "SearchDiaryMsg", "ViewPhysicalMsg", "ViewBodilyFunctionsMsg", "ViewWeightMsg", "AddEditWeightMsg", "AddEditBloodPressureMsg", "AddEditBodilyFunctionsMsg", "AddEditTemperatureMsg", "ViewFinancialMsg", "ViewAssetMsg", "ViewAssetsSummaryMsg", "ViewFitnessMsg", "ViewWorkoutsMsg", "ViewExercisesMsg", "ViewTrainingPlanMsg", "AddEditTrainingPlanMsg", "ViewWorkoutMsg", "AddEditWorkoutMsg", "ViewExerciseMsg", "AddEditExerciseMsg", "ViewExerciseRecordMsg", "AddEditExerciseRecordMsg", "AddAllWorkoutExerciseRecordsMsg", "AddEditWorkoutRecordMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Omnicv.Client.App.Msg", [], Msg, () => [[["Item", option_type(Route_$reflection())]], [["Item", Route_$reflection()]], [["Item", Msg_$reflection_1()]], [["Item", class_type("System.DateTime")]], [], [["Item", Response_AvailableUserInfo_$reflection()]], [["Item", int32_type]], [["Item", class_type("System.Exception")]], [["Item", Msg_$reflection_2()]], [["Item", Msg_$reflection_3()]], [["Item", Msg_$reflection_4()]], [["Item", Msg_$reflection_5()]], [["Item", Msg_$reflection_6()]], [["Item", Msg_$reflection_7()]], [["Item", ViewProfile_Msg_$reflection()]], [["Item", AddEditProfile_Msg_$reflection()]], [["Item", Msg_$reflection_8()]], [["Item", Msg$2_$reflection(DiaryRecord_$reflection(), EditHelperData$1_$reflection(DiaryRecord_$reflection()))]], [["Item", Msg$2_$reflection(ReviewRecord_$reflection(), EditHelperData$1_$reflection(ReviewRecord_$reflection()))]], [["Item", Msg$2_$reflection(InteractionRecord_$reflection(), EditHelperData$1_$reflection(InteractionRecord_$reflection()))]], [["Item", Msg_$reflection_9()]], [["Item", Msg$1_$reflection(UnifiedRecord_$reflection())]], [["Item", Msg$1_$reflection(BodilyFunctionsRecord_$reflection())]], [["Item", Msg$1_$reflection(WeightRecord_$reflection())]], [["Item", Msg$2_$reflection(WeightRecord_$reflection(), list_type(tuple_type(EventInfo_$reflection(), WeightRecord_$reflection())))]], [["Item", Msg$2_$reflection(BloodPressureRecord_$reflection(), list_type(tuple_type(EventInfo_$reflection(), BloodPressureRecord_$reflection())))]], [["Item", Msg$2_$reflection(BodilyFunctionsRecord_$reflection(), list_type(tuple_type(EventInfo_$reflection(), BodilyFunctionsRecord_$reflection())))]], [["Item", Msg$2_$reflection(TemperatureRecord_$reflection(), list_type(tuple_type(EventInfo_$reflection(), TemperatureRecord_$reflection())))]], [["Item", Msg_$reflection_10()]], [["Item", Msg_$reflection_11()]], [["Item", Msg_$reflection_12()]], [["Item", Main_Msg_$reflection()]], [["Item", Msg$1_$reflection_1(Workout_$reflection())]], [["Item", Msg$1_$reflection_1(Exercise_$reflection())]], [["Item", Msg$2_$reflection_1(TrainingPlanWorkoutRecords_$reflection(), Workout_$reflection())]], [["Item", Msg$2_$reflection_2(TrainingPlan_$reflection(), FitnessEditHelperData_$reflection())]], [["Item", Msg$2_$reflection_1(WorkoutRecords_$reflection(), Exercise_$reflection())]], [["Item", Msg$2_$reflection_2(Workout_$reflection(), FitnessEditHelperData_$reflection())]], [["Item", Msg$2_$reflection_1(Exercise_$reflection(), tuple_type(EventInfo_$reflection(), ExerciseRecord_$reflection()))]], [["Item", Msg$2_$reflection_2(Exercise_$reflection(), FitnessEditHelperData_$reflection())]], [["Item", ExerciseRecord_Msg_$reflection()]], [["Item", Msg_$reflection_13()]], [["Item", ExerciseRecordsMany_MsgMany_$reflection()]], [["Item", Msg$2_$reflection(WorkoutRecord_$reflection(), WorkoutRecords_$reflection())]]]);
}

export class Model extends Record {
    constructor(CurrentRoute, ActivePage, NavigationModel, Session, SessionLoading, LastSessionRefresh) {
        super();
        this.CurrentRoute = CurrentRoute;
        this.ActivePage = ActivePage;
        this.NavigationModel = NavigationModel;
        this.Session = Session;
        this.SessionLoading = SessionLoading;
        this.LastSessionRefresh = LastSessionRefresh;
    }
}

export function Model_$reflection() {
    return record_type("Omnicv.Client.App.Model", [], Model, () => [["CurrentRoute", option_type(Route_$reflection())], ["ActivePage", Page_$reflection()], ["NavigationModel", Model_$reflection_12()], ["Session", Session_$reflection()], ["SessionLoading", bool_type], ["LastSessionRefresh", class_type("System.DateTime")]]);
}

export function Model__NeedsTimer(this$) {
    const activeWorkout = map((tuple) => tuple[1], Session__GetActiveWorkoutRecord(this$.Session));
    if ((activeWorkout != null) && (value_15(activeWorkout).FinishTime == null)) {
        return true;
    }
    else {
        return this$.NavigationModel.CurrentTimerExpiry != null;
    }
}

function setRouteValue(route, model) {
    switch (route.tag) {
        case 1:
            return [new Model(model.CurrentRoute, new Page(0, [new AnonymousPage(1, [])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_none()];
        case 3: {
            const patternInput_1 = init_1();
            return [new Model(model.CurrentRoute, new Page(0, [new AnonymousPage(4, [patternInput_1[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_1) => (new Msg(10, [Item_1])), patternInput_1[1])];
        }
        case 2: {
            const patternInput_2 = init_2(model.Session);
            return [new Model(model.CurrentRoute, new Page(0, [new AnonymousPage(2, [patternInput_2[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_2) => (new Msg(11, [Item_2])), patternInput_2[1])];
        }
        case 8: {
            const patternInput_3 = init_3(model.Session);
            return [new Model(model.CurrentRoute, new Page(0, [new AnonymousPage(3, [patternInput_3[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_3) => (new Msg(12, [Item_3])), patternInput_3[1])];
        }
        case 7: {
            const patternInput_4 = init_4(route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(0, [new AnonymousPage(5, [patternInput_4[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_4) => (new Msg(13, [Item_4])), patternInput_4[1])];
        }
        case 4: {
            const patternInput_5 = ViewProfile_init(model.Session);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(0, [patternInput_5[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_5) => (new Msg(14, [Item_5])), patternInput_5[1])];
        }
        case 5: {
            const patternInput_6 = AddEditProfile_initNew();
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(1, [patternInput_6[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_6) => (new Msg(15, [Item_6])), patternInput_6[1])];
        }
        case 6: {
            const patternInput_7 = AddEditProfile_initEdit(route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(1, [patternInput_7[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_7) => (new Msg(15, [Item_7])), patternInput_7[1])];
        }
        case 9: {
            const patternInput_8 = init_5(route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(2, [patternInput_8[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_8) => (new Msg(16, [Item_8])), patternInput_8[1])];
        }
        case 10: {
            const patternInput_9 = DiaryEditingView$1__InitNew(diaryEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(4, [patternInput_9[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_9) => (new Msg(17, [Item_9])), patternInput_9[1])];
        }
        case 11: {
            const patternInput_10 = DiaryEditingView$1__InitEdit(diaryEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(4, [patternInput_10[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_10) => (new Msg(17, [Item_10])), patternInput_10[1])];
        }
        case 12: {
            const patternInput_11 = DiaryEditingView$1__InitNew(reviewEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(5, [patternInput_11[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_11) => (new Msg(18, [Item_11])), patternInput_11[1])];
        }
        case 13: {
            const patternInput_12 = DiaryEditingView$1__InitEdit(reviewEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(5, [patternInput_12[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_12) => (new Msg(18, [Item_12])), patternInput_12[1])];
        }
        case 14: {
            const patternInput_13 = DiaryEditingView$1__InitNew(interactionEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(6, [patternInput_13[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_13) => (new Msg(19, [Item_13])), patternInput_13[1])];
        }
        case 15: {
            const patternInput_14 = DiaryEditingView$1__InitEdit(interactionEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(6, [patternInput_14[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_14) => (new Msg(19, [Item_14])), patternInput_14[1])];
        }
        case 16: {
            const patternInput_15 = init_6(model.Session, new SearchType(0, [route.fields[0]]));
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(3, [patternInput_15[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_15) => (new Msg(20, [Item_15])), patternInput_15[1])];
        }
        case 17: {
            const patternInput_16 = init_6(model.Session, new SearchType(1, []));
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(3, [patternInput_16[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_16) => (new Msg(20, [Item_16])), patternInput_16[1])];
        }
        case 18: {
            const patternInput_17 = PhysicalView_init();
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(7, [patternInput_17[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_17) => (new Msg(21, [Item_17])), patternInput_17[1])];
        }
        case 19: {
            const patternInput_18 = BodilyFunctionsView_init();
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(9, [patternInput_18[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_18) => (new Msg(22, [Item_18])), patternInput_18[1])];
        }
        case 20: {
            const patternInput_19 = WeightView_init();
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(8, [patternInput_19[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_19) => (new Msg(23, [Item_19])), patternInput_19[1])];
        }
        case 21: {
            const patternInput_20 = Physical_PhysicalView$1__InitNew_5D846BF8(Physical_weightEditing, model.Session);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(10, [patternInput_20[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_20) => (new Msg(24, [Item_20])), patternInput_20[1])];
        }
        case 22: {
            const patternInput_21 = Physical_PhysicalView$1__InitEdit(Physical_weightEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(10, [patternInput_21[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_21) => (new Msg(24, [Item_21])), patternInput_21[1])];
        }
        case 25: {
            const patternInput_22 = Physical_PhysicalView$1__InitNew_5D846BF8(Physical_bloodPressureEditing, model.Session);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(11, [patternInput_22[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_22) => (new Msg(25, [Item_22])), patternInput_22[1])];
        }
        case 26: {
            const patternInput_23 = Physical_PhysicalView$1__InitEdit(Physical_bloodPressureEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(11, [patternInput_23[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_23) => (new Msg(25, [Item_23])), patternInput_23[1])];
        }
        case 23: {
            const patternInput_24 = Physical_PhysicalView$1__InitNew_5D846BF8(Physical_bodilyFunctionsEditing, model.Session);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(12, [patternInput_24[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_24) => (new Msg(26, [Item_24])), patternInput_24[1])];
        }
        case 24: {
            const patternInput_25 = Physical_PhysicalView$1__InitEdit(Physical_bodilyFunctionsEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(12, [patternInput_25[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_25) => (new Msg(26, [Item_25])), patternInput_25[1])];
        }
        case 27: {
            const patternInput_26 = Physical_PhysicalView$1__InitNew_5D846BF8(Physical_temperatureEditing, model.Session);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(13, [patternInput_26[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_26) => (new Msg(27, [Item_26])), patternInput_26[1])];
        }
        case 28: {
            const patternInput_27 = Physical_PhysicalView$1__InitEdit(Physical_temperatureEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(13, [patternInput_27[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_27) => (new Msg(27, [Item_27])), patternInput_27[1])];
        }
        case 29: {
            const patternInput_28 = Main_init();
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(14, [patternInput_28[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_28) => (new Msg(28, [Item_28])), patternInput_28[1])];
        }
        case 30: {
            const patternInput_29 = init_7(route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(15, [patternInput_29[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_29) => (new Msg(29, [Item_29])), patternInput_29[1])];
        }
        case 31: {
            const patternInput_30 = init_8();
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(16, [patternInput_30[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_30) => (new Msg(30, [Item_30])), patternInput_30[1])];
        }
        case 32: {
            const patternInput_31 = Main_init_1();
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(17, [patternInput_31[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_31) => (new Msg(31, [Item_31])), patternInput_31[1])];
        }
        case 39: {
            const patternInput_32 = Workouts_init();
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(18, [patternInput_32[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_32) => (new Msg(32, [Item_32])), patternInput_32[1])];
        }
        case 43: {
            const patternInput_33 = Exercises_init();
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(19, [patternInput_33[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_33) => (new Msg(33, [Item_33])), patternInput_33[1])];
        }
        case 35: {
            const patternInput_34 = TrainingPlan_init(route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(20, [patternInput_34[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_34) => (new Msg(34, [Item_34])), patternInput_34[1])];
        }
        case 33: {
            const patternInput_35 = AddEditFitnessView$1__InitNew_5D846BF8(trainingPlanEditing, model.Session);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(21, [patternInput_35[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_35) => (new Msg(35, [Item_35])), patternInput_35[1])];
        }
        case 34: {
            const patternInput_36 = AddEditFitnessView$1__InitEdit(trainingPlanEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(21, [patternInput_36[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_36) => (new Msg(35, [Item_36])), patternInput_36[1])];
        }
        case 38: {
            const patternInput_37 = Workout_init(route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(22, [patternInput_37[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_37) => (new Msg(36, [Item_37])), patternInput_37[1])];
        }
        case 36: {
            const patternInput_38 = AddEditFitnessView$1__InitNew_5D846BF8(workoutEditing, model.Session);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(23, [patternInput_38[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_38) => (new Msg(37, [Item_38])), patternInput_38[1])];
        }
        case 37: {
            const patternInput_39 = AddEditFitnessView$1__InitEdit(workoutEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(23, [patternInput_39[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_39) => (new Msg(37, [Item_39])), patternInput_39[1])];
        }
        case 42: {
            const patternInput_40 = Exercise_init(route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(24, [patternInput_40[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_40) => (new Msg(38, [Item_40])), patternInput_40[1])];
        }
        case 40: {
            const patternInput_41 = AddEditFitnessView$1__InitNew_5D846BF8(exerciseEditing, model.Session);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(25, [patternInput_41[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_41) => (new Msg(39, [Item_41])), patternInput_41[1])];
        }
        case 41: {
            const patternInput_42 = AddEditFitnessView$1__InitEdit(exerciseEditing, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(25, [patternInput_42[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_42) => (new Msg(39, [Item_42])), patternInput_42[1])];
        }
        case 44: {
            const patternInput_43 = ExerciseRecord_init(route.fields[0], route.fields[1]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(26, [patternInput_43[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_43) => (new Msg(40, [Item_43])), patternInput_43[1])];
        }
        case 45: {
            const patternInput_44 = initNew(model.Session, route.fields[0], route.fields[1], route.fields[2]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(27, [patternInput_44[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_44) => (new Msg(41, [Item_44])), patternInput_44[1])];
        }
        case 46: {
            const patternInput_45 = initEdit(model.Session, route.fields[0], route.fields[1]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(27, [patternInput_45[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_45) => (new Msg(41, [Item_45])), patternInput_45[1])];
        }
        case 47: {
            const patternInput_46 = ExerciseRecordsMany_initNewMany(model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(28, [patternInput_46[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_46) => (new Msg(42, [Item_46])), patternInput_46[1])];
        }
        case 48: {
            const patternInput_47 = Workout_WorkoutEditView__InitNew(workoutRecordEditor, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(29, [patternInput_47[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_47) => (new Msg(43, [Item_47])), patternInput_47[1])];
        }
        case 49: {
            const patternInput_48 = Workout_WorkoutEditView__InitEdit(workoutRecordEditor, model.Session, route.fields[0]);
            return [new Model(model.CurrentRoute, new Page(1, [new SessionPage(29, [patternInput_48[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item_48) => (new Msg(43, [Item_48])), patternInput_48[1])];
        }
        default: {
            const patternInput = init_9(model.Session);
            return [new Model(model.CurrentRoute, new Page(0, [new AnonymousPage(0, [patternInput[0]])]), model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh), Cmd_batch(ofArray([Cmd_map((Item) => (new Msg(9, [Item])), patternInput[1]), singleton((dispatch) => {
                dispatch(new Msg(2, [new Msg_1(3, [model.Session])]));
            })]))];
        }
    }
}

function setRoute(optRoute, model) {
    const model_1 = new Model(optRoute, model.ActivePage, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh);
    if (optRoute != null) {
        return setRouteValue(optRoute, model_1);
    }
    else {
        return [new Model(model_1.CurrentRoute, new Page(0, [new AnonymousPage(1, [])]), model_1.NavigationModel, model_1.Session, model_1.SessionLoading, model_1.LastSessionRefresh), Cmd_none()];
    }
}

function refreshSession(newSession, model, forceRefresh) {
    let msg_1;
    Session__UpdateCurrentProvile(newSession);
    const newModel = new Model(model.CurrentRoute, model.ActivePage, model.NavigationModel, newSession, false, model.LastSessionRefresh);
    const cmd = singleton((dispatch) => {
        dispatch(new Msg(2, [new Msg_1(3, [newSession])]));
    });
    if (forceRefresh) {
        if (model.CurrentRoute != null) {
            return [newModel, Cmd_batch(ofArray([cmd, (msg_1 = (new Msg(1, [value_15(model.CurrentRoute)])), singleton((dispatch_1) => {
                dispatch_1(msg_1);
            }))]))];
        }
        else {
            return [newModel, cmd];
        }
    }
    else {
        return [newModel, cmd];
    }
}

function update(msg, model) {
    let bind$0040_1, bind$0040_2, userInfo;
    switch (msg.tag) {
        case 1:
            return setRouteValue(msg.fields[0], model);
        case 2: {
            const subMsg = msg.fields[0];
            const patternInput = update_1(model.Session, subMsg, model.NavigationModel);
            const subModel = patternInput[0];
            const updatedSession = (subMsg.tag === 8) ? Session__SetActiveWorkoutRecord_Z2D8A2414(model.Session, subMsg.fields[0]) : model.Session;
            return [new Model(model.CurrentRoute, model.ActivePage, subModel, equals(subModel.LogInState, new LogInState(2, [])) ? (new Session(false, undefined, updatedSession.CurrentProfile)) : updatedSession, model.SessionLoading, model.LastSessionRefresh), Cmd_map((Item) => (new Msg(2, [Item])), patternInput[1])];
        }
        case 3:
            if (model.Session.LoggedIn) {
                return [model, Cmd_map((Item_1) => (new Msg(2, [Item_1])), singleton((dispatch) => {
                    dispatch(new Msg_1(4, [msg.fields[0]]));
                }))];
            }
            else {
                return [model, Cmd_none()];
            }
        case 10: {
            const matchValue = model.ActivePage;
            let matchResult, subModel_1;
            if (matchValue.tag === 0) {
                if (matchValue.fields[0].tag === 4) {
                    matchResult = 0;
                    subModel_1 = matchValue.fields[0].fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const patternInput_1 = update_2(msg.fields[0], subModel_1);
                    const subModelRes = patternInput_1[0];
                    const newSession_1 = (subModelRes.Response != null) ? (new Session(true, subModelRes.Response, model.Session.CurrentProfile)) : model.Session;
                    let tupledArg_2;
                    let tupledArg_1;
                    const tupledArg = [subModelRes, patternInput_1[1]];
                    tupledArg_1 = Tuple_mapFirst((arg) => (new Page(0, [new AnonymousPage(4, [arg])])), tupledArg[0], tupledArg[1]);
                    tupledArg_2 = Tuple_mapFirst((page) => (new Model(model.CurrentRoute, page, model.NavigationModel, newSession_1, model.SessionLoading, model.LastSessionRefresh)), tupledArg_1[0], tupledArg_1[1]);
                    return Tuple_mapSecond((cmd_4) => Cmd_map((Item_4) => (new Msg(10, [Item_4])), cmd_4), tupledArg_2[0], tupledArg_2[1]);
                }
                default: {
                    console.log(some(`Login deciding to do nothing: model=${model}`));
                    return [model, Cmd_none()];
                }
            }
        }
        case 9: {
            const matchValue_1 = model.ActivePage;
            let matchResult_1, subModel_2;
            if (matchValue_1.tag === 0) {
                if (matchValue_1.fields[0].tag === 0) {
                    matchResult_1 = 0;
                    subModel_2 = matchValue_1.fields[0].fields[0];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    let tupledArg_5;
                    let tupledArg_4;
                    const tupledArg_3 = update_3(model.Session, msg.fields[0], subModel_2);
                    tupledArg_4 = Tuple_mapFirst((arg_1) => (new Page(0, [new AnonymousPage(0, [arg_1])])), tupledArg_3[0], tupledArg_3[1]);
                    tupledArg_5 = Tuple_mapFirst((page_1) => (new Model(model.CurrentRoute, page_1, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_4[0], tupledArg_4[1]);
                    return Tuple_mapSecond((cmd_5) => Cmd_map((Item_7) => (new Msg(9, [Item_7])), cmd_5), tupledArg_5[0], tupledArg_5[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 11: {
            const matchValue_2 = model.ActivePage;
            let matchResult_2, subModel_3;
            if (matchValue_2.tag === 0) {
                if (matchValue_2.fields[0].tag === 2) {
                    matchResult_2 = 0;
                    subModel_3 = matchValue_2.fields[0].fields[0];
                }
                else {
                    matchResult_2 = 1;
                }
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0: {
                    let tupledArg_8;
                    let tupledArg_7;
                    const tupledArg_6 = update_4(msg.fields[0], subModel_3);
                    tupledArg_7 = Tuple_mapFirst((arg_2) => (new Page(0, [new AnonymousPage(2, [arg_2])])), tupledArg_6[0], tupledArg_6[1]);
                    tupledArg_8 = Tuple_mapFirst((page_2) => (new Model(model.CurrentRoute, page_2, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_7[0], tupledArg_7[1]);
                    return Tuple_mapSecond((cmd_6) => Cmd_map((Item_10) => (new Msg(11, [Item_10])), cmd_6), tupledArg_8[0], tupledArg_8[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 12: {
            const matchValue_3 = model.ActivePage;
            let matchResult_3, subModel_4;
            if (matchValue_3.tag === 0) {
                if (matchValue_3.fields[0].tag === 3) {
                    matchResult_3 = 0;
                    subModel_4 = matchValue_3.fields[0].fields[0];
                }
                else {
                    matchResult_3 = 1;
                }
            }
            else {
                matchResult_3 = 1;
            }
            switch (matchResult_3) {
                case 0: {
                    let tupledArg_11;
                    let tupledArg_10;
                    const tupledArg_9 = update_5(model.Session, msg.fields[0], subModel_4);
                    tupledArg_10 = Tuple_mapFirst((arg_3) => (new Page(0, [new AnonymousPage(3, [arg_3])])), tupledArg_9[0], tupledArg_9[1]);
                    tupledArg_11 = Tuple_mapFirst((page_3) => (new Model(model.CurrentRoute, page_3, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_10[0], tupledArg_10[1]);
                    return Tuple_mapSecond((cmd_7) => Cmd_map((Item_13) => (new Msg(12, [Item_13])), cmd_7), tupledArg_11[0], tupledArg_11[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 13: {
            const matchValue_4 = model.ActivePage;
            let matchResult_4, subModel_5;
            if (matchValue_4.tag === 0) {
                if (matchValue_4.fields[0].tag === 5) {
                    matchResult_4 = 0;
                    subModel_5 = matchValue_4.fields[0].fields[0];
                }
                else {
                    matchResult_4 = 1;
                }
            }
            else {
                matchResult_4 = 1;
            }
            switch (matchResult_4) {
                case 0: {
                    let tupledArg_14;
                    let tupledArg_13;
                    const tupledArg_12 = update_6(msg.fields[0], subModel_5);
                    tupledArg_13 = Tuple_mapFirst((arg_4) => (new Page(0, [new AnonymousPage(5, [arg_4])])), tupledArg_12[0], tupledArg_12[1]);
                    tupledArg_14 = Tuple_mapFirst((page_4) => (new Model(model.CurrentRoute, page_4, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_13[0], tupledArg_13[1]);
                    return Tuple_mapSecond((cmd_8) => Cmd_map((Item_16) => (new Msg(13, [Item_16])), cmd_8), tupledArg_14[0], tupledArg_14[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 14: {
            const subMsg_6 = msg.fields[0];
            const matchValue_5 = model.ActivePage;
            let matchResult_5, subModel_6;
            if (matchValue_5.tag === 1) {
                if (matchValue_5.fields[0].tag === 0) {
                    matchResult_5 = 0;
                    subModel_6 = matchValue_5.fields[0].fields[0];
                }
                else {
                    matchResult_5 = 1;
                }
            }
            else {
                matchResult_5 = 1;
            }
            switch (matchResult_5) {
                case 0: {
                    let patternInput_2;
                    let tupledArg_17;
                    let tupledArg_16;
                    const tupledArg_15 = ViewProfile_update(subMsg_6, subModel_6);
                    tupledArg_16 = Tuple_mapFirst((arg_5) => (new Page(1, [new SessionPage(0, [arg_5])])), tupledArg_15[0], tupledArg_15[1]);
                    tupledArg_17 = Tuple_mapFirst((page_5) => (new Model(model.CurrentRoute, page_5, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_16[0], tupledArg_16[1]);
                    patternInput_2 = Tuple_mapSecond((cmd_9) => Cmd_map((Item_19) => (new Msg(14, [Item_19])), cmd_9), tupledArg_17[0], tupledArg_17[1]);
                    const subModel1 = patternInput_2[0];
                    const cmd_10 = patternInput_2[1];
                    switch (subMsg_6.tag) {
                        case 5:
                            return [subModel1, Cmd_batch(ofArray([singleton((dispatch_1) => {
                                dispatch_1(new Msg(6, [subMsg_6.fields[0]]));
                            }), cmd_10]))];
                        case 4:
                            return [subModel1, Cmd_batch(ofArray([singleton((dispatch_2) => {
                                dispatch_2(new Msg(4, []));
                            }), cmd_10]))];
                        default:
                            return [subModel1, cmd_10];
                    }
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 15: {
            const subMsg_7 = msg.fields[0];
            const matchValue_6 = model.ActivePage;
            let matchResult_6, subModel_7;
            if (matchValue_6.tag === 1) {
                if (matchValue_6.fields[0].tag === 1) {
                    matchResult_6 = 0;
                    subModel_7 = matchValue_6.fields[0].fields[0];
                }
                else {
                    matchResult_6 = 1;
                }
            }
            else {
                matchResult_6 = 1;
            }
            switch (matchResult_6) {
                case 0: {
                    let patternInput_3;
                    let tupledArg_20;
                    let tupledArg_19;
                    const tupledArg_18 = AddEditProfile_update(subMsg_7, subModel_7);
                    tupledArg_19 = Tuple_mapFirst((arg_6) => (new Page(1, [new SessionPage(1, [arg_6])])), tupledArg_18[0], tupledArg_18[1]);
                    tupledArg_20 = Tuple_mapFirst((page_6) => (new Model(model.CurrentRoute, page_6, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_19[0], tupledArg_19[1]);
                    patternInput_3 = Tuple_mapSecond((cmd_11) => Cmd_map((Item_22) => (new Msg(15, [Item_22])), cmd_11), tupledArg_20[0], tupledArg_20[1]);
                    const subModel1_1 = patternInput_3[0];
                    const cmd_12 = patternInput_3[1];
                    switch (subMsg_7.tag) {
                        case 3:
                        case 4:
                            return [subModel1_1, Cmd_batch(ofArray([singleton((dispatch_3) => {
                                dispatch_3(new Msg(4, []));
                            }), cmd_12]))];
                        default:
                            return [subModel1_1, cmd_12];
                    }
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 16: {
            const matchValue_7 = model.ActivePage;
            let matchResult_7, subModel_8;
            if (matchValue_7.tag === 1) {
                if (matchValue_7.fields[0].tag === 2) {
                    matchResult_7 = 0;
                    subModel_8 = matchValue_7.fields[0].fields[0];
                }
                else {
                    matchResult_7 = 1;
                }
            }
            else {
                matchResult_7 = 1;
            }
            switch (matchResult_7) {
                case 0: {
                    let tupledArg_23;
                    let tupledArg_22;
                    const tupledArg_21 = update_7(model.Session, msg.fields[0], subModel_8);
                    tupledArg_22 = Tuple_mapFirst((arg_7) => (new Page(1, [new SessionPage(2, [arg_7])])), tupledArg_21[0], tupledArg_21[1]);
                    tupledArg_23 = Tuple_mapFirst((page_7) => (new Model(model.CurrentRoute, page_7, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_22[0], tupledArg_22[1]);
                    return Tuple_mapSecond((cmd_13) => Cmd_map((Item_25) => (new Msg(16, [Item_25])), cmd_13), tupledArg_23[0], tupledArg_23[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 17: {
            const matchValue_8 = model.ActivePage;
            let matchResult_8, subModel_9;
            if (matchValue_8.tag === 1) {
                if (matchValue_8.fields[0].tag === 4) {
                    matchResult_8 = 0;
                    subModel_9 = matchValue_8.fields[0].fields[0];
                }
                else {
                    matchResult_8 = 1;
                }
            }
            else {
                matchResult_8 = 1;
            }
            switch (matchResult_8) {
                case 0: {
                    let tupledArg_26;
                    let tupledArg_25;
                    const tupledArg_24 = DiaryEditingView$1__Update(diaryEditing, model.Session, msg.fields[0], subModel_9);
                    tupledArg_25 = Tuple_mapFirst((arg_8) => (new Page(1, [new SessionPage(4, [arg_8])])), tupledArg_24[0], tupledArg_24[1]);
                    tupledArg_26 = Tuple_mapFirst((page_8) => (new Model(model.CurrentRoute, page_8, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_25[0], tupledArg_25[1]);
                    return Tuple_mapSecond((cmd_14) => Cmd_map((Item_28) => (new Msg(17, [Item_28])), cmd_14), tupledArg_26[0], tupledArg_26[1]);
                }
                default: {
                    console.warn(some("WARN: AddEditDiaryMsg: Not on a AddEditDiary page"));
                    return [model, Cmd_none()];
                }
            }
        }
        case 18: {
            const matchValue_9 = model.ActivePage;
            let matchResult_9, subModel_10;
            if (matchValue_9.tag === 1) {
                if (matchValue_9.fields[0].tag === 5) {
                    matchResult_9 = 0;
                    subModel_10 = matchValue_9.fields[0].fields[0];
                }
                else {
                    matchResult_9 = 1;
                }
            }
            else {
                matchResult_9 = 1;
            }
            switch (matchResult_9) {
                case 0: {
                    let tupledArg_29;
                    let tupledArg_28;
                    const tupledArg_27 = DiaryEditingView$1__Update(reviewEditing, model.Session, msg.fields[0], subModel_10);
                    tupledArg_28 = Tuple_mapFirst((arg_9) => (new Page(1, [new SessionPage(5, [arg_9])])), tupledArg_27[0], tupledArg_27[1]);
                    tupledArg_29 = Tuple_mapFirst((page_9) => (new Model(model.CurrentRoute, page_9, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_28[0], tupledArg_28[1]);
                    return Tuple_mapSecond((cmd_15) => Cmd_map((Item_31) => (new Msg(18, [Item_31])), cmd_15), tupledArg_29[0], tupledArg_29[1]);
                }
                default: {
                    console.warn(some("WARN: AddEditReviewMsg: Not on a AddEditReview page"));
                    return [model, Cmd_none()];
                }
            }
        }
        case 19: {
            const matchValue_10 = model.ActivePage;
            let matchResult_10, subModel_11;
            if (matchValue_10.tag === 1) {
                if (matchValue_10.fields[0].tag === 6) {
                    matchResult_10 = 0;
                    subModel_11 = matchValue_10.fields[0].fields[0];
                }
                else {
                    matchResult_10 = 1;
                }
            }
            else {
                matchResult_10 = 1;
            }
            switch (matchResult_10) {
                case 0: {
                    let tupledArg_32;
                    let tupledArg_31;
                    const tupledArg_30 = DiaryEditingView$1__Update(interactionEditing, model.Session, msg.fields[0], subModel_11);
                    tupledArg_31 = Tuple_mapFirst((arg_10) => (new Page(1, [new SessionPage(6, [arg_10])])), tupledArg_30[0], tupledArg_30[1]);
                    tupledArg_32 = Tuple_mapFirst((page_10) => (new Model(model.CurrentRoute, page_10, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_31[0], tupledArg_31[1]);
                    return Tuple_mapSecond((cmd_16) => Cmd_map((Item_34) => (new Msg(19, [Item_34])), cmd_16), tupledArg_32[0], tupledArg_32[1]);
                }
                default: {
                    console.warn(some("WARN: AddEditInteractionMsg: Not on a AddEditInteraction page"));
                    return [model, Cmd_none()];
                }
            }
        }
        case 20: {
            const matchValue_11 = model.ActivePage;
            let matchResult_11, subModel_12;
            if (matchValue_11.tag === 1) {
                if (matchValue_11.fields[0].tag === 3) {
                    matchResult_11 = 0;
                    subModel_12 = matchValue_11.fields[0].fields[0];
                }
                else {
                    matchResult_11 = 1;
                }
            }
            else {
                matchResult_11 = 1;
            }
            switch (matchResult_11) {
                case 0: {
                    let tupledArg_35;
                    let tupledArg_34;
                    const tupledArg_33 = update_8(model.Session, msg.fields[0], subModel_12);
                    tupledArg_34 = Tuple_mapFirst((arg_11) => (new Page(1, [new SessionPage(3, [arg_11])])), tupledArg_33[0], tupledArg_33[1]);
                    tupledArg_35 = Tuple_mapFirst((page_11) => (new Model(model.CurrentRoute, page_11, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_34[0], tupledArg_34[1]);
                    return Tuple_mapSecond((cmd_17) => Cmd_map((Item_37) => (new Msg(20, [Item_37])), cmd_17), tupledArg_35[0], tupledArg_35[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 21: {
            const matchValue_12 = model.ActivePage;
            let matchResult_12, subModel_13;
            if (matchValue_12.tag === 1) {
                if (matchValue_12.fields[0].tag === 7) {
                    matchResult_12 = 0;
                    subModel_13 = matchValue_12.fields[0].fields[0];
                }
                else {
                    matchResult_12 = 1;
                }
            }
            else {
                matchResult_12 = 1;
            }
            switch (matchResult_12) {
                case 0: {
                    let tupledArg_38;
                    let tupledArg_37;
                    const tupledArg_36 = PhysicalView_update(model.Session)(msg.fields[0])(subModel_13);
                    tupledArg_37 = Tuple_mapFirst((arg_12) => (new Page(1, [new SessionPage(7, [arg_12])])), tupledArg_36[0], tupledArg_36[1]);
                    tupledArg_38 = Tuple_mapFirst((page_12) => (new Model(model.CurrentRoute, page_12, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_37[0], tupledArg_37[1]);
                    return Tuple_mapSecond((cmd_18) => Cmd_map((Item_40) => (new Msg(21, [Item_40])), cmd_18), tupledArg_38[0], tupledArg_38[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 22: {
            const matchValue_13 = model.ActivePage;
            let matchResult_13, subModel_14;
            if (matchValue_13.tag === 1) {
                if (matchValue_13.fields[0].tag === 9) {
                    matchResult_13 = 0;
                    subModel_14 = matchValue_13.fields[0].fields[0];
                }
                else {
                    matchResult_13 = 1;
                }
            }
            else {
                matchResult_13 = 1;
            }
            switch (matchResult_13) {
                case 0: {
                    let tupledArg_41;
                    let tupledArg_40;
                    const tupledArg_39 = BodilyFunctionsView_update(model.Session)(msg.fields[0])(subModel_14);
                    tupledArg_40 = Tuple_mapFirst((arg_13) => (new Page(1, [new SessionPage(9, [arg_13])])), tupledArg_39[0], tupledArg_39[1]);
                    tupledArg_41 = Tuple_mapFirst((page_13) => (new Model(model.CurrentRoute, page_13, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_40[0], tupledArg_40[1]);
                    return Tuple_mapSecond((cmd_19) => Cmd_map((Item_43) => (new Msg(22, [Item_43])), cmd_19), tupledArg_41[0], tupledArg_41[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 23: {
            const matchValue_14 = model.ActivePage;
            let matchResult_14, subModel_15;
            if (matchValue_14.tag === 1) {
                if (matchValue_14.fields[0].tag === 8) {
                    matchResult_14 = 0;
                    subModel_15 = matchValue_14.fields[0].fields[0];
                }
                else {
                    matchResult_14 = 1;
                }
            }
            else {
                matchResult_14 = 1;
            }
            switch (matchResult_14) {
                case 0: {
                    let tupledArg_44;
                    let tupledArg_43;
                    const tupledArg_42 = WeightView_update(model.Session)(msg.fields[0])(subModel_15);
                    tupledArg_43 = Tuple_mapFirst((arg_14) => (new Page(1, [new SessionPage(8, [arg_14])])), tupledArg_42[0], tupledArg_42[1]);
                    tupledArg_44 = Tuple_mapFirst((page_14) => (new Model(model.CurrentRoute, page_14, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_43[0], tupledArg_43[1]);
                    return Tuple_mapSecond((cmd_20) => Cmd_map((Item_46) => (new Msg(23, [Item_46])), cmd_20), tupledArg_44[0], tupledArg_44[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 24: {
            const matchValue_15 = model.ActivePage;
            let matchResult_15, subModel_16;
            if (matchValue_15.tag === 1) {
                if (matchValue_15.fields[0].tag === 10) {
                    matchResult_15 = 0;
                    subModel_16 = matchValue_15.fields[0].fields[0];
                }
                else {
                    matchResult_15 = 1;
                }
            }
            else {
                matchResult_15 = 1;
            }
            switch (matchResult_15) {
                case 0: {
                    let tupledArg_47;
                    let tupledArg_46;
                    const tupledArg_45 = Physical_PhysicalView$1__Update(Physical_weightEditing, model.Session, msg.fields[0], subModel_16);
                    tupledArg_46 = Tuple_mapFirst((arg_15) => (new Page(1, [new SessionPage(10, [arg_15])])), tupledArg_45[0], tupledArg_45[1]);
                    tupledArg_47 = Tuple_mapFirst((page_15) => (new Model(model.CurrentRoute, page_15, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_46[0], tupledArg_46[1]);
                    return Tuple_mapSecond((cmd_21) => Cmd_map((Item_49) => (new Msg(24, [Item_49])), cmd_21), tupledArg_47[0], tupledArg_47[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 25: {
            const matchValue_16 = model.ActivePage;
            let matchResult_16, subModel_17;
            if (matchValue_16.tag === 1) {
                if (matchValue_16.fields[0].tag === 11) {
                    matchResult_16 = 0;
                    subModel_17 = matchValue_16.fields[0].fields[0];
                }
                else {
                    matchResult_16 = 1;
                }
            }
            else {
                matchResult_16 = 1;
            }
            switch (matchResult_16) {
                case 0: {
                    let tupledArg_50;
                    let tupledArg_49;
                    const tupledArg_48 = Physical_PhysicalView$1__Update(Physical_bloodPressureEditing, model.Session, msg.fields[0], subModel_17);
                    tupledArg_49 = Tuple_mapFirst((arg_16) => (new Page(1, [new SessionPage(11, [arg_16])])), tupledArg_48[0], tupledArg_48[1]);
                    tupledArg_50 = Tuple_mapFirst((page_16) => (new Model(model.CurrentRoute, page_16, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_49[0], tupledArg_49[1]);
                    return Tuple_mapSecond((cmd_22) => Cmd_map((Item_52) => (new Msg(25, [Item_52])), cmd_22), tupledArg_50[0], tupledArg_50[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 26: {
            const matchValue_17 = model.ActivePage;
            let matchResult_17, subModel_18;
            if (matchValue_17.tag === 1) {
                if (matchValue_17.fields[0].tag === 12) {
                    matchResult_17 = 0;
                    subModel_18 = matchValue_17.fields[0].fields[0];
                }
                else {
                    matchResult_17 = 1;
                }
            }
            else {
                matchResult_17 = 1;
            }
            switch (matchResult_17) {
                case 0: {
                    let tupledArg_53;
                    let tupledArg_52;
                    const tupledArg_51 = Physical_PhysicalView$1__Update(Physical_bodilyFunctionsEditing, model.Session, msg.fields[0], subModel_18);
                    tupledArg_52 = Tuple_mapFirst((arg_17) => (new Page(1, [new SessionPage(12, [arg_17])])), tupledArg_51[0], tupledArg_51[1]);
                    tupledArg_53 = Tuple_mapFirst((page_17) => (new Model(model.CurrentRoute, page_17, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_52[0], tupledArg_52[1]);
                    return Tuple_mapSecond((cmd_23) => Cmd_map((Item_55) => (new Msg(26, [Item_55])), cmd_23), tupledArg_53[0], tupledArg_53[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 27: {
            const matchValue_18 = model.ActivePage;
            let matchResult_18, subModel_19;
            if (matchValue_18.tag === 1) {
                if (matchValue_18.fields[0].tag === 13) {
                    matchResult_18 = 0;
                    subModel_19 = matchValue_18.fields[0].fields[0];
                }
                else {
                    matchResult_18 = 1;
                }
            }
            else {
                matchResult_18 = 1;
            }
            switch (matchResult_18) {
                case 0: {
                    let tupledArg_56;
                    let tupledArg_55;
                    const tupledArg_54 = Physical_PhysicalView$1__Update(Physical_temperatureEditing, model.Session, msg.fields[0], subModel_19);
                    tupledArg_55 = Tuple_mapFirst((arg_18) => (new Page(1, [new SessionPage(13, [arg_18])])), tupledArg_54[0], tupledArg_54[1]);
                    tupledArg_56 = Tuple_mapFirst((page_18) => (new Model(model.CurrentRoute, page_18, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_55[0], tupledArg_55[1]);
                    return Tuple_mapSecond((cmd_24) => Cmd_map((Item_58) => (new Msg(27, [Item_58])), cmd_24), tupledArg_56[0], tupledArg_56[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 28: {
            const matchValue_19 = model.ActivePage;
            let matchResult_19, subModel_20;
            if (matchValue_19.tag === 1) {
                if (matchValue_19.fields[0].tag === 14) {
                    matchResult_19 = 0;
                    subModel_20 = matchValue_19.fields[0].fields[0];
                }
                else {
                    matchResult_19 = 1;
                }
            }
            else {
                matchResult_19 = 1;
            }
            switch (matchResult_19) {
                case 0: {
                    let tupledArg_59;
                    let tupledArg_58;
                    const tupledArg_57 = Main_update(model.Session, msg.fields[0], subModel_20);
                    tupledArg_58 = Tuple_mapFirst((arg_19) => (new Page(1, [new SessionPage(14, [arg_19])])), tupledArg_57[0], tupledArg_57[1]);
                    tupledArg_59 = Tuple_mapFirst((page_19) => (new Model(model.CurrentRoute, page_19, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_58[0], tupledArg_58[1]);
                    return Tuple_mapSecond((cmd_25) => Cmd_map((Item_61) => (new Msg(28, [Item_61])), cmd_25), tupledArg_59[0], tupledArg_59[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 29: {
            const matchValue_20 = model.ActivePage;
            let matchResult_20, subModel_21;
            if (matchValue_20.tag === 1) {
                if (matchValue_20.fields[0].tag === 15) {
                    matchResult_20 = 0;
                    subModel_21 = matchValue_20.fields[0].fields[0];
                }
                else {
                    matchResult_20 = 1;
                }
            }
            else {
                matchResult_20 = 1;
            }
            switch (matchResult_20) {
                case 0: {
                    let tupledArg_62;
                    let tupledArg_61;
                    const tupledArg_60 = update_9(model.Session, msg.fields[0], subModel_21);
                    tupledArg_61 = Tuple_mapFirst((arg_20) => (new Page(1, [new SessionPage(15, [arg_20])])), tupledArg_60[0], tupledArg_60[1]);
                    tupledArg_62 = Tuple_mapFirst((page_20) => (new Model(model.CurrentRoute, page_20, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_61[0], tupledArg_61[1]);
                    return Tuple_mapSecond((cmd_26) => Cmd_map((Item_64) => (new Msg(29, [Item_64])), cmd_26), tupledArg_62[0], tupledArg_62[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 30: {
            const matchValue_21 = model.ActivePage;
            let matchResult_21, subModel_22;
            if (matchValue_21.tag === 1) {
                if (matchValue_21.fields[0].tag === 16) {
                    matchResult_21 = 0;
                    subModel_22 = matchValue_21.fields[0].fields[0];
                }
                else {
                    matchResult_21 = 1;
                }
            }
            else {
                matchResult_21 = 1;
            }
            switch (matchResult_21) {
                case 0: {
                    let tupledArg_65;
                    let tupledArg_64;
                    const tupledArg_63 = update_10(model.Session, msg.fields[0], subModel_22);
                    tupledArg_64 = Tuple_mapFirst((arg_21) => (new Page(1, [new SessionPage(16, [arg_21])])), tupledArg_63[0], tupledArg_63[1]);
                    tupledArg_65 = Tuple_mapFirst((page_21) => (new Model(model.CurrentRoute, page_21, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_64[0], tupledArg_64[1]);
                    return Tuple_mapSecond((cmd_27) => Cmd_map((Item_67) => (new Msg(30, [Item_67])), cmd_27), tupledArg_65[0], tupledArg_65[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 31: {
            const matchValue_22 = model.ActivePage;
            let matchResult_22, subModel_23;
            if (matchValue_22.tag === 1) {
                if (matchValue_22.fields[0].tag === 17) {
                    matchResult_22 = 0;
                    subModel_23 = matchValue_22.fields[0].fields[0];
                }
                else {
                    matchResult_22 = 1;
                }
            }
            else {
                matchResult_22 = 1;
            }
            switch (matchResult_22) {
                case 0: {
                    let tupledArg_68;
                    let tupledArg_67;
                    const tupledArg_66 = Main_update_1(model.Session, msg.fields[0], subModel_23);
                    tupledArg_67 = Tuple_mapFirst((arg_22) => (new Page(1, [new SessionPage(17, [arg_22])])), tupledArg_66[0], tupledArg_66[1]);
                    tupledArg_68 = Tuple_mapFirst((page_22) => (new Model(model.CurrentRoute, page_22, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_67[0], tupledArg_67[1]);
                    return Tuple_mapSecond((cmd_28) => Cmd_map((Item_70) => (new Msg(31, [Item_70])), cmd_28), tupledArg_68[0], tupledArg_68[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 32: {
            const matchValue_23 = model.ActivePage;
            let matchResult_23, subModel_24;
            if (matchValue_23.tag === 1) {
                if (matchValue_23.fields[0].tag === 18) {
                    matchResult_23 = 0;
                    subModel_24 = matchValue_23.fields[0].fields[0];
                }
                else {
                    matchResult_23 = 1;
                }
            }
            else {
                matchResult_23 = 1;
            }
            switch (matchResult_23) {
                case 0: {
                    let tupledArg_71;
                    let tupledArg_70;
                    const tupledArg_69 = Workouts_update(model.Session, msg.fields[0], subModel_24);
                    tupledArg_70 = Tuple_mapFirst((arg_23) => (new Page(1, [new SessionPage(18, [arg_23])])), tupledArg_69[0], tupledArg_69[1]);
                    tupledArg_71 = Tuple_mapFirst((page_23) => (new Model(model.CurrentRoute, page_23, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_70[0], tupledArg_70[1]);
                    return Tuple_mapSecond((cmd_29) => Cmd_map((Item_73) => (new Msg(32, [Item_73])), cmd_29), tupledArg_71[0], tupledArg_71[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 33: {
            const matchValue_24 = model.ActivePage;
            let matchResult_24, subModel_25;
            if (matchValue_24.tag === 1) {
                if (matchValue_24.fields[0].tag === 19) {
                    matchResult_24 = 0;
                    subModel_25 = matchValue_24.fields[0].fields[0];
                }
                else {
                    matchResult_24 = 1;
                }
            }
            else {
                matchResult_24 = 1;
            }
            switch (matchResult_24) {
                case 0: {
                    let tupledArg_74;
                    let tupledArg_73;
                    const tupledArg_72 = Exercises_update(model.Session, msg.fields[0], subModel_25);
                    tupledArg_73 = Tuple_mapFirst((arg_24) => (new Page(1, [new SessionPage(19, [arg_24])])), tupledArg_72[0], tupledArg_72[1]);
                    tupledArg_74 = Tuple_mapFirst((page_24) => (new Model(model.CurrentRoute, page_24, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_73[0], tupledArg_73[1]);
                    return Tuple_mapSecond((cmd_30) => Cmd_map((Item_76) => (new Msg(33, [Item_76])), cmd_30), tupledArg_74[0], tupledArg_74[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 34: {
            const matchValue_25 = model.ActivePage;
            let matchResult_25, subModel_26;
            if (matchValue_25.tag === 1) {
                if (matchValue_25.fields[0].tag === 20) {
                    matchResult_25 = 0;
                    subModel_26 = matchValue_25.fields[0].fields[0];
                }
                else {
                    matchResult_25 = 1;
                }
            }
            else {
                matchResult_25 = 1;
            }
            switch (matchResult_25) {
                case 0: {
                    let tupledArg_77;
                    let tupledArg_76;
                    const tupledArg_75 = TrainingPlan_update(model.Session, msg.fields[0], subModel_26);
                    tupledArg_76 = Tuple_mapFirst((arg_25) => (new Page(1, [new SessionPage(20, [arg_25])])), tupledArg_75[0], tupledArg_75[1]);
                    tupledArg_77 = Tuple_mapFirst((page_25) => (new Model(model.CurrentRoute, page_25, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_76[0], tupledArg_76[1]);
                    return Tuple_mapSecond((cmd_31) => Cmd_map((Item_79) => (new Msg(34, [Item_79])), cmd_31), tupledArg_77[0], tupledArg_77[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 35: {
            const matchValue_26 = model.ActivePage;
            let matchResult_26, subModel_27;
            if (matchValue_26.tag === 1) {
                if (matchValue_26.fields[0].tag === 21) {
                    matchResult_26 = 0;
                    subModel_27 = matchValue_26.fields[0].fields[0];
                }
                else {
                    matchResult_26 = 1;
                }
            }
            else {
                matchResult_26 = 1;
            }
            switch (matchResult_26) {
                case 0: {
                    let tupledArg_80;
                    let tupledArg_79;
                    const tupledArg_78 = SimpleFormView$2__Update(trainingPlanEditing, model.Session, msg.fields[0], subModel_27);
                    tupledArg_79 = Tuple_mapFirst((arg_26) => (new Page(1, [new SessionPage(21, [arg_26])])), tupledArg_78[0], tupledArg_78[1]);
                    tupledArg_80 = Tuple_mapFirst((page_26) => (new Model(model.CurrentRoute, page_26, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_79[0], tupledArg_79[1]);
                    return Tuple_mapSecond((cmd_32) => Cmd_map((Item_82) => (new Msg(35, [Item_82])), cmd_32), tupledArg_80[0], tupledArg_80[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 36: {
            const matchValue_27 = model.ActivePage;
            let matchResult_27, subModel_28;
            if (matchValue_27.tag === 1) {
                if (matchValue_27.fields[0].tag === 22) {
                    matchResult_27 = 0;
                    subModel_28 = matchValue_27.fields[0].fields[0];
                }
                else {
                    matchResult_27 = 1;
                }
            }
            else {
                matchResult_27 = 1;
            }
            switch (matchResult_27) {
                case 0: {
                    let tupledArg_83;
                    let tupledArg_82;
                    const tupledArg_81 = Workout_update(model.Session, msg.fields[0], subModel_28);
                    tupledArg_82 = Tuple_mapFirst((arg_27) => (new Page(1, [new SessionPage(22, [arg_27])])), tupledArg_81[0], tupledArg_81[1]);
                    tupledArg_83 = Tuple_mapFirst((page_27) => (new Model(model.CurrentRoute, page_27, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_82[0], tupledArg_82[1]);
                    return Tuple_mapSecond((cmd_33) => Cmd_map((Item_85) => (new Msg(36, [Item_85])), cmd_33), tupledArg_83[0], tupledArg_83[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 37: {
            const matchValue_28 = model.ActivePage;
            let matchResult_28, subModel_29;
            if (matchValue_28.tag === 1) {
                if (matchValue_28.fields[0].tag === 23) {
                    matchResult_28 = 0;
                    subModel_29 = matchValue_28.fields[0].fields[0];
                }
                else {
                    matchResult_28 = 1;
                }
            }
            else {
                matchResult_28 = 1;
            }
            switch (matchResult_28) {
                case 0: {
                    let tupledArg_86;
                    let tupledArg_85;
                    const tupledArg_84 = SimpleFormView$2__Update(workoutEditing, model.Session, msg.fields[0], subModel_29);
                    tupledArg_85 = Tuple_mapFirst((arg_28) => (new Page(1, [new SessionPage(23, [arg_28])])), tupledArg_84[0], tupledArg_84[1]);
                    tupledArg_86 = Tuple_mapFirst((page_28) => (new Model(model.CurrentRoute, page_28, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_85[0], tupledArg_85[1]);
                    return Tuple_mapSecond((cmd_34) => Cmd_map((Item_88) => (new Msg(37, [Item_88])), cmd_34), tupledArg_86[0], tupledArg_86[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 38: {
            const matchValue_29 = model.ActivePage;
            let matchResult_29, subModel_30;
            if (matchValue_29.tag === 1) {
                if (matchValue_29.fields[0].tag === 24) {
                    matchResult_29 = 0;
                    subModel_30 = matchValue_29.fields[0].fields[0];
                }
                else {
                    matchResult_29 = 1;
                }
            }
            else {
                matchResult_29 = 1;
            }
            switch (matchResult_29) {
                case 0: {
                    let tupledArg_89;
                    let tupledArg_88;
                    const tupledArg_87 = Exercise_update(model.Session, msg.fields[0], subModel_30);
                    tupledArg_88 = Tuple_mapFirst((arg_29) => (new Page(1, [new SessionPage(24, [arg_29])])), tupledArg_87[0], tupledArg_87[1]);
                    tupledArg_89 = Tuple_mapFirst((page_29) => (new Model(model.CurrentRoute, page_29, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_88[0], tupledArg_88[1]);
                    return Tuple_mapSecond((cmd_35) => Cmd_map((Item_91) => (new Msg(38, [Item_91])), cmd_35), tupledArg_89[0], tupledArg_89[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 39: {
            const matchValue_30 = model.ActivePage;
            let matchResult_30, subModel_31;
            if (matchValue_30.tag === 1) {
                if (matchValue_30.fields[0].tag === 25) {
                    matchResult_30 = 0;
                    subModel_31 = matchValue_30.fields[0].fields[0];
                }
                else {
                    matchResult_30 = 1;
                }
            }
            else {
                matchResult_30 = 1;
            }
            switch (matchResult_30) {
                case 0: {
                    let tupledArg_92;
                    let tupledArg_91;
                    const tupledArg_90 = SimpleFormView$2__Update(exerciseEditing, model.Session, msg.fields[0], subModel_31);
                    tupledArg_91 = Tuple_mapFirst((arg_30) => (new Page(1, [new SessionPage(25, [arg_30])])), tupledArg_90[0], tupledArg_90[1]);
                    tupledArg_92 = Tuple_mapFirst((page_30) => (new Model(model.CurrentRoute, page_30, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_91[0], tupledArg_91[1]);
                    return Tuple_mapSecond((cmd_36) => Cmd_map((Item_94) => (new Msg(39, [Item_94])), cmd_36), tupledArg_92[0], tupledArg_92[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 40: {
            const matchValue_31 = model.ActivePage;
            let matchResult_31, subModel_32;
            if (matchValue_31.tag === 1) {
                if (matchValue_31.fields[0].tag === 26) {
                    matchResult_31 = 0;
                    subModel_32 = matchValue_31.fields[0].fields[0];
                }
                else {
                    matchResult_31 = 1;
                }
            }
            else {
                matchResult_31 = 1;
            }
            switch (matchResult_31) {
                case 0: {
                    let tupledArg_95;
                    let tupledArg_94;
                    const tupledArg_93 = ExerciseRecord_update(model.Session, msg.fields[0], subModel_32);
                    tupledArg_94 = Tuple_mapFirst((arg_31) => (new Page(1, [new SessionPage(26, [arg_31])])), tupledArg_93[0], tupledArg_93[1]);
                    tupledArg_95 = Tuple_mapFirst((page_31) => (new Model(model.CurrentRoute, page_31, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_94[0], tupledArg_94[1]);
                    return Tuple_mapSecond((cmd_37) => Cmd_map((Item_97) => (new Msg(40, [Item_97])), cmd_37), tupledArg_95[0], tupledArg_95[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 41: {
            const subMsg_33 = msg.fields[0];
            const matchValue_32 = model.ActivePage;
            let matchResult_32, subModel_33;
            if (matchValue_32.tag === 1) {
                if (matchValue_32.fields[0].tag === 27) {
                    matchResult_32 = 0;
                    subModel_33 = matchValue_32.fields[0].fields[0];
                }
                else {
                    matchResult_32 = 1;
                }
            }
            else {
                matchResult_32 = 1;
            }
            switch (matchResult_32) {
                case 0: {
                    let patternInput_4;
                    let tupledArg_98;
                    let tupledArg_97;
                    const tupledArg_96 = update_11(model.Session, subMsg_33, subModel_33);
                    tupledArg_97 = Tuple_mapFirst((arg_32) => (new Page(1, [new SessionPage(27, [arg_32])])), tupledArg_96[0], tupledArg_96[1]);
                    tupledArg_98 = Tuple_mapFirst((page_32) => (new Model(model.CurrentRoute, page_32, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_97[0], tupledArg_97[1]);
                    patternInput_4 = Tuple_mapSecond((cmd_38) => Cmd_map((Item_100) => (new Msg(41, [Item_100])), cmd_38), tupledArg_98[0], tupledArg_98[1]);
                    const resultModel = patternInput_4[0];
                    const cmd_39 = patternInput_4[1];
                    const matchValue_33 = getSetTimerMsg(subMsg_33);
                    if (matchValue_33 != null) {
                        const dateTime_1 = matchValue_33;
                        return [resultModel, Cmd_batch(ofArray([cmd_39, singleton((dispatch_4) => {
                            dispatch_4(new Msg(2, [new Msg_1(9, [dateTime_1])]));
                        })]))];
                    }
                    else {
                        return [resultModel, cmd_39];
                    }
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 42: {
            const matchValue_34 = model.ActivePage;
            let matchResult_33, subModel_34;
            if (matchValue_34.tag === 1) {
                if (matchValue_34.fields[0].tag === 28) {
                    matchResult_33 = 0;
                    subModel_34 = matchValue_34.fields[0].fields[0];
                }
                else {
                    matchResult_33 = 1;
                }
            }
            else {
                matchResult_33 = 1;
            }
            switch (matchResult_33) {
                case 0: {
                    let tupledArg_101;
                    let tupledArg_100;
                    const tupledArg_99 = ExerciseRecordsMany_update(model.Session, msg.fields[0], subModel_34);
                    tupledArg_100 = Tuple_mapFirst((arg_33) => (new Page(1, [new SessionPage(28, [arg_33])])), tupledArg_99[0], tupledArg_99[1]);
                    tupledArg_101 = Tuple_mapFirst((page_33) => (new Model(model.CurrentRoute, page_33, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_100[0], tupledArg_100[1]);
                    return Tuple_mapSecond((cmd_40) => Cmd_map((Item_103) => (new Msg(42, [Item_103])), cmd_40), tupledArg_101[0], tupledArg_101[1]);
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 43: {
            const subMsg_35 = msg.fields[0];
            const matchValue_35 = model.ActivePage;
            let matchResult_34, subModel_35;
            if (matchValue_35.tag === 1) {
                if (matchValue_35.fields[0].tag === 29) {
                    matchResult_34 = 0;
                    subModel_35 = matchValue_35.fields[0].fields[0];
                }
                else {
                    matchResult_34 = 1;
                }
            }
            else {
                matchResult_34 = 1;
            }
            switch (matchResult_34) {
                case 0: {
                    let patternInput_5;
                    let tupledArg_104;
                    let tupledArg_103;
                    const tupledArg_102 = Workout_WorkoutEditView__Update(workoutRecordEditor, model.Session, subMsg_35, subModel_35);
                    tupledArg_103 = Tuple_mapFirst((arg_34) => (new Page(1, [new SessionPage(29, [arg_34])])), tupledArg_102[0], tupledArg_102[1]);
                    tupledArg_104 = Tuple_mapFirst((page_34) => (new Model(model.CurrentRoute, page_34, model.NavigationModel, model.Session, model.SessionLoading, model.LastSessionRefresh)), tupledArg_103[0], tupledArg_103[1]);
                    patternInput_5 = Tuple_mapSecond((cmd_41) => Cmd_map((Item_106) => (new Msg(43, [Item_106])), cmd_41), tupledArg_104[0], tupledArg_104[1]);
                    const resultModel_1 = patternInput_5[0];
                    const cmd_42 = patternInput_5[1];
                    if (subMsg_35.tag === 6) {
                        const eventInfo = subMsg_35.fields[0];
                        if (!Model$2__IsEditing(subModel_35)) {
                            const newSession_2 = Session__SetActiveWorkoutRecord_Z2D8A2414(resultModel_1.Session, [eventInfo, (bind$0040_1 = subModel_35.Record, new WorkoutRecord(eventInfo.Id, bind$0040_1.WorkoutId, bind$0040_1.Progress, bind$0040_1.FinishTime, bind$0040_1.Notes))]);
                            return [new Model(resultModel_1.CurrentRoute, resultModel_1.ActivePage, resultModel_1.NavigationModel, newSession_2, resultModel_1.SessionLoading, resultModel_1.LastSessionRefresh), Cmd_batch(ofArray([singleton((dispatch_5) => {
                                dispatch_5(new Msg(2, [new Msg_1(3, [newSession_2])]));
                            }), cmd_42]))];
                        }
                        else {
                            return [resultModel_1, cmd_42];
                        }
                    }
                    else {
                        return [resultModel_1, cmd_42];
                    }
                }
                default:
                    return [model, Cmd_none()];
            }
        }
        case 8: {
            const subMsg_36 = msg.fields[0];
            const matchValue_36 = model.ActivePage;
            let matchResult_35, subModel_36, subModel_37;
            if (matchValue_36.tag === 1) {
                switch (matchValue_36.fields[0].tag) {
                    case 4: {
                        matchResult_35 = 0;
                        break;
                    }
                    case 5: {
                        matchResult_35 = 1;
                        break;
                    }
                    case 6: {
                        matchResult_35 = 2;
                        break;
                    }
                    case 10: {
                        matchResult_35 = 3;
                        break;
                    }
                    case 11: {
                        matchResult_35 = 4;
                        break;
                    }
                    case 12: {
                        matchResult_35 = 5;
                        break;
                    }
                    case 13: {
                        matchResult_35 = 6;
                        break;
                    }
                    case 27: {
                        matchResult_35 = 7;
                        subModel_36 = matchValue_36.fields[0].fields[0];
                        break;
                    }
                    case 28: {
                        matchResult_35 = 8;
                        subModel_37 = matchValue_36.fields[0].fields[0];
                        break;
                    }
                    case 29: {
                        matchResult_35 = 9;
                        break;
                    }
                    default:
                        matchResult_35 = 10;
                }
            }
            else {
                matchResult_35 = 10;
            }
            switch (matchResult_35) {
                case 0:
                    return [model, singleton((dispatch_6) => {
                        dispatch_6(new Msg(17, [new Msg$2(7, [subMsg_36])]));
                    })];
                case 1:
                    return [model, singleton((dispatch_7) => {
                        dispatch_7(new Msg(18, [new Msg$2(7, [subMsg_36])]));
                    })];
                case 2:
                    return [model, singleton((dispatch_8) => {
                        dispatch_8(new Msg(19, [new Msg$2(7, [subMsg_36])]));
                    })];
                case 3:
                    return [model, singleton((dispatch_9) => {
                        dispatch_9(new Msg(24, [new Msg$2(7, [subMsg_36])]));
                    })];
                case 4:
                    return [model, singleton((dispatch_10) => {
                        dispatch_10(new Msg(25, [new Msg$2(7, [subMsg_36])]));
                    })];
                case 5:
                    return [model, singleton((dispatch_11) => {
                        dispatch_11(new Msg(26, [new Msg$2(7, [subMsg_36])]));
                    })];
                case 6:
                    return [model, singleton((dispatch_12) => {
                        dispatch_12(new Msg(27, [new Msg$2(7, [subMsg_36])]));
                    })];
                case 7: {
                    const resMsg = mapModelToEIMMsg(subModel_36, subMsg_36);
                    return [model, singleton((dispatch_13) => {
                        dispatch_13(new Msg(41, [resMsg]));
                    })];
                }
                case 8: {
                    const resMsg_1 = ExerciseRecordsMany_mapModelToEIMMsg(subModel_37, subMsg_36);
                    return [model, singleton((dispatch_14) => {
                        dispatch_14(new Msg(42, [resMsg_1]));
                    })];
                }
                case 9:
                    return [model, singleton((dispatch_15) => {
                        dispatch_15(new Msg(43, [new Msg$2(7, [subMsg_36])]));
                    })];
                default: {
                    console.warn(some(`WARN: AppEIMMsg on page=${model.ActivePage}: Not on any page that supports location`));
                    return [model, Cmd_none()];
                }
            }
        }
        case 4:
            return [new Model(model.CurrentRoute, model.ActivePage, model.NavigationModel, model.Session, true, model.LastSessionRefresh), Cmd_OfAsyncWith_either((x_105) => {
                Cmd_OfAsync_start(x_105);
            }, anonService.GetAvailableUserInfo, undefined, (Item_107) => (new Msg(5, [Item_107])), (Item_108) => (new Msg(7, [Item_108])))];
        case 6:
            return refreshSession((bind$0040_2 = model.Session, new Session(bind$0040_2.LoggedIn, bind$0040_2.UserInfo, msg.fields[0])), model, true);
        case 5: {
            const info = msg.fields[0];
            return refreshSession((info.tag === 1) ? ((userInfo = info.fields[0], (common.updateConfiguration(userInfo.ClientConfigVariables), new Session(true, userInfo, undefined)))) : ((common.updateConfiguration(info.fields[0].ClientConfigVariables), new Session(false, undefined, undefined))), model, model.SessionLoading);
        }
        case 7: {
            console.error(some(msg.fields[0]));
            return [new Model(model.CurrentRoute, model.ActivePage, model.NavigationModel, model.Session, false, model.LastSessionRefresh), Cmd_none()];
        }
        default:
            return setRoute(msg.fields[0], model);
    }
}

function init(location) {
    const session = Session_get_Default();
    const patternInput = init_10(session);
    const patternInput_1 = setRoute(location, new Model(undefined, new Page(0, [new AnonymousPage(0, [Model_Default()])]), patternInput[0], session, true, common.getNow()));
    return [patternInput_1[0], Cmd_batch(ofArray([singleton((dispatch) => {
        dispatch(new Msg(4, []));
    }), patternInput_1[1], Cmd_map((Item) => (new Msg(2, [Item])), patternInput[1])]))];
}

function makeFluid(element) {
    return box$0027(empty(), singleton(element));
}

function lazyView2() {
    return (view_1) => Common_lazyView2(uncurry2(view_1));
}

function contentFromAuthPage(model, authPage, dispatch) {
    switch (authPage.tag) {
        case 1:
            return lazyView2()((model_2) => ((dispatch_2) => AddEditProfile_view(model_2, dispatch_2)))(authPage.fields[0])((arg_1) => {
                dispatch(new Msg(15, [arg_1]));
            });
        case 4:
            return lazyView2()((model_3) => ((dispatch_3) => DiaryEditingView$1__View(diaryEditing, model_3, dispatch_3)))(authPage.fields[0])((arg_2) => {
                dispatch(new Msg(17, [arg_2]));
            });
        case 5:
            return lazyView2()((model_4) => ((dispatch_4) => DiaryEditingView$1__View(reviewEditing, model_4, dispatch_4)))(authPage.fields[0])((arg_3) => {
                dispatch(new Msg(18, [arg_3]));
            });
        case 6:
            return lazyView2()((model_5) => ((dispatch_5) => DiaryEditingView$1__View(interactionEditing, model_5, dispatch_5)))(authPage.fields[0])((arg_4) => {
                dispatch(new Msg(19, [arg_4]));
            });
        case 2:
            return lazyView2()((model_6) => ((dispatch_6) => view_2(model.Session, model_6, dispatch_6)))(authPage.fields[0])((arg_5) => {
                dispatch(new Msg(16, [arg_5]));
            });
        case 3:
            return lazyView2()((model_7) => ((dispatch_7) => view_3(model_7, dispatch_7)))(authPage.fields[0])((arg_6) => {
                dispatch(new Msg(20, [arg_6]));
            });
        case 7:
            return PhysicalView_view(model.Session, authPage.fields[0], (arg_7) => {
                dispatch(new Msg(21, [arg_7]));
            });
        case 9:
            return BodilyFunctionsView_viewList(model.Session, authPage.fields[0], (arg_8) => {
                dispatch(new Msg(22, [arg_8]));
            });
        case 8:
            return WeightView_viewList(model.Session, authPage.fields[0], (arg_9) => {
                dispatch(new Msg(23, [arg_9]));
            });
        case 15:
            return view_4(authPage.fields[0], (arg_10) => {
                dispatch(new Msg(29, [arg_10]));
            });
        case 16:
            return view_5(authPage.fields[0], (arg_11) => {
                dispatch(new Msg(30, [arg_11]));
            });
        case 10:
            return Physical_PhysicalView$1__View(Physical_weightEditing, authPage.fields[0], (arg_12) => {
                dispatch(new Msg(24, [arg_12]));
            });
        case 11:
            return Physical_PhysicalView$1__View(Physical_bloodPressureEditing, authPage.fields[0], (arg_13) => {
                dispatch(new Msg(25, [arg_13]));
            });
        case 12:
            return Physical_PhysicalView$1__View(Physical_bodilyFunctionsEditing, authPage.fields[0], (arg_14) => {
                dispatch(new Msg(26, [arg_14]));
            });
        case 13:
            return Physical_PhysicalView$1__View(Physical_temperatureEditing, authPage.fields[0], (arg_15) => {
                dispatch(new Msg(27, [arg_15]));
            });
        case 14:
            return Main_view(model.Session, authPage.fields[0], (arg_16) => {
                dispatch(new Msg(28, [arg_16]));
            });
        case 17:
            return lazyView2()((model_12) => ((dispatch_12) => Main_view_1(model.Session, model_12, dispatch_12)))(authPage.fields[0])((arg_17) => {
                dispatch(new Msg(31, [arg_17]));
            });
        case 18:
            return lazyView2()((model_13) => ((dispatch_13) => Workouts_view(model_13, dispatch_13)))(authPage.fields[0])((arg_18) => {
                dispatch(new Msg(32, [arg_18]));
            });
        case 19:
            return lazyView2()((model_14) => ((dispatch_14) => Exercises_view(model_14, dispatch_14)))(authPage.fields[0])((arg_19) => {
                dispatch(new Msg(33, [arg_19]));
            });
        case 20:
            return lazyView2()((model_15) => ((dispatch_15) => TrainingPlan_view(model_15, dispatch_15)))(authPage.fields[0])((arg_20) => {
                dispatch(new Msg(34, [arg_20]));
            });
        case 21:
            return lazyView2()((model_16) => ((dispatch_16) => AddEditFitnessView$1__View(trainingPlanEditing, model.Session, model_16, dispatch_16)))(authPage.fields[0])((arg_21) => {
                dispatch(new Msg(35, [arg_21]));
            });
        case 22:
            return lazyView2()((model_17) => ((dispatch_17) => Workout_view(model.Session, model_17, dispatch_17)))(authPage.fields[0])((arg_22) => {
                dispatch(new Msg(36, [arg_22]));
            });
        case 23:
            return lazyView2()((model_18) => ((dispatch_18) => AddEditFitnessView$1__View(workoutEditing, model.Session, model_18, dispatch_18)))(authPage.fields[0])((arg_23) => {
                dispatch(new Msg(37, [arg_23]));
            });
        case 24:
            return lazyView2()((model_19) => ((dispatch_19) => Exercise_view(model.Session, model_19, dispatch_19)))(authPage.fields[0])((arg_24) => {
                dispatch(new Msg(38, [arg_24]));
            });
        case 25:
            return lazyView2()((model_20) => ((dispatch_20) => AddEditFitnessView$1__View(exerciseEditing, model.Session, model_20, dispatch_20)))(authPage.fields[0])((arg_25) => {
                dispatch(new Msg(39, [arg_25]));
            });
        case 26:
            return lazyView2()((model_21) => ((_dispatch) => ExerciseRecord_view(model.Session, model_21, _dispatch)))(authPage.fields[0])((arg_26) => {
                dispatch(new Msg(40, [arg_26]));
            });
        case 27:
            return lazyView2()((model_22) => ((dispatch_21) => view_6(model.Session, model_22, dispatch_21)))(authPage.fields[0])((arg_27) => {
                dispatch(new Msg(41, [arg_27]));
            });
        case 28:
            return lazyView2()((model_23) => ((dispatch_22) => ExerciseRecordsMany_view(model_23, dispatch_22)))(authPage.fields[0])((arg_28) => {
                dispatch(new Msg(42, [arg_28]));
            });
        case 29:
            return lazyView2()((model_24) => ((dispatch_23) => Workout_WorkoutEditView__View(workoutRecordEditor, model_24, dispatch_23)))(authPage.fields[0])((arg_29) => {
                dispatch(new Msg(43, [arg_29]));
            });
        default:
            return lazyView2()((model_1) => ((dispatch_1) => ViewProfile_view(model.Session, model_1, dispatch_1)))(authPage.fields[0])((arg) => {
                dispatch(new Msg(14, [arg]));
            });
    }
}

function contentFromPage(model, page, dispatch) {
    if (page.tag === 1) {
        if (model.Session.LoggedIn) {
            if (Session__GetCurrentProfile(model.Session) != null) {
                return contentFromAuthPage(model, page.fields[0], dispatch);
            }
            else {
                const children = singleton(createElement("p", {
                    children: ["Stale session info, wait for the refresh to finish"],
                }));
                return createElement("div", {
                    children: reactApi.Children.toArray(Array.from(children)),
                });
            }
        }
        else {
            const children_2 = ofArray([createElement("p", {
                children: ["Not logged in, cannot display the current page. Log in first please"],
            }), createElement("a", createObj(ofArray([Router_href(new Route(3, [])), ["children", "Login page"]])))]);
            return createElement("div", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            });
        }
    }
    else {
        switch (page.fields[0].tag) {
            case 1:
                return "Page not found";
            case 2:
                return view_7(page.fields[0].fields[0], (arg_1) => {
                    dispatch(new Msg(11, [arg_1]));
                });
            case 3:
                return view_8(page.fields[0].fields[0], (arg_2) => {
                    dispatch(new Msg(12, [arg_2]));
                });
            case 5:
                return view_9(page.fields[0].fields[0], (arg_3) => {
                    dispatch(new Msg(13, [arg_3]));
                });
            case 4:
                return view_10(page.fields[0].fields[0], (arg_4) => {
                    dispatch(new Msg(10, [arg_4]));
                });
            default:
                return view_11(model.Session, page.fields[0].fields[0], (arg) => {
                    dispatch(new Msg(9, [arg]));
                });
        }
    }
}

function view(model, dispatch) {
    let elems;
    const elms = singleton(createElement("div", createObj(Helpers_combineClasses("column", ofArray([["className", "is-8"], ["className", "is-offset-2"], (elems = toList(delay(() => append(singleton_1(lazyView2()((model_1) => ((dispatch_1) => view_12(model_1, dispatch_1)))(model.NavigationModel)((arg) => {
        dispatch(new Msg(2, [arg]));
    })), delay(() => append(model.SessionLoading ? singleton_1("Loading, please wait") : singleton_1(renderCatchSimple("Error rendering", makeFluid(contentFromPage(model, model.ActivePage, dispatch)))), delay(() => {
        let children;
        return singleton_1(footer(empty(), singleton(content(singleton(new Option(3, [singleton(new Modifier_IModifier(5, [new Screen(0, []), new TextAlignment_Option(0, [])]))])), singleton((children = ofArray([createElement("a", createObj(ofArray([Router_href(new Route(7, ["terms"])), ["children", "Terms & conditions"]]))), " | ", createElement("a", createObj(ofArray([Router_href(new Route(7, ["privacy"])), ["children", "Privacy"]]))), " | ", createElement("a", createObj(ofArray([Router_href(new Route(8, [])), ["children", "Contact"]])))]), createElement("p", {
            children: reactApi.Children.toArray(Array.from(children)),
        })))))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))));
    return createElement("div", {
        className: "columns",
        children: reactApi.Children.toArray(Array.from(elms)),
    });
}

export const timer = (dispatch) => {
    const intervalId = setInterval(() => {
        dispatch(new Msg(3, [common.getNow()]));
    }, 5000) | 0;
    return {
        Dispose() {
            console.debug(`Disposing of timer ${intervalId}`);
            clearInterval(intervalId);
        },
    };
};

const subscribeLocation = (dispatch) => {
    subscribeLocation_1((arg) => {
        dispatch(new Msg(8, [arg]));
    });
    return {
        Dispose() {
        },
    };
};

function subscriptions(model) {
    const locationSub = [singleton("location"), subscribeLocation];
    if (Model__NeedsTimer(model)) {
        return ofArray([locationSub, [singleton("timer"), timer]]);
    }
    else {
        return singleton(locationSub);
    }
}

ProgramModule_run(Program_withReactSynchronous("app-root", ProgramModule_toNavigable((location_1) => parseHash(RouteModule_routeParser, location_1), setRoute, ProgramModule_withSubscription(subscriptions, ProgramModule_mkProgram(init, update, view)))));

